module.exports = __webpack_public_path__ + "static/media/ServiceNow-logo_3a52.svg";